export default theme => ({
  spinner: {
    flex: 1,
    minHeight: "600px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
});
